import type { FilterModel } from 'ag-grid-community';

/**
 * Converts AG Grid filter model to backend SSRM convention: date filters use Date objects,
 * and each filter entry includes a `name` property. Used when building `convertedFilterModel` for the SSRM request.
 */
export function convertFilterModelToBackend(
  filterModel: FilterModel | null | undefined,
): Array<Record<string, unknown>> | null {
  if (!filterModel) return null;
  return Object.keys(filterModel).map(key => {
    const filter = (filterModel as Record<string, unknown>)[key] as Record<string, unknown> | undefined;
    if (!filter) return { name: key };

    if (filter.filterType === 'date') {
      const dateFrom = filter.dateFrom as string | undefined;
      const dateTo = filter.dateTo as string | undefined;
      return {
        name: key,
        filterType: 'date',
        type: filter.type,
        filter: dateFrom ? new Date(dateFrom) : undefined,
        filterTo: dateTo ? new Date(dateTo) : undefined,
      };
    }

    return { name: key, ...filter };
  });
}
